const SearchTicketPage = () =>
  import(
    /* webpackChunkName: "SearchViews" */ '../views/search/SearchTicketPage.vue'
    );
const SearchUserPage = () =>
  import(
    /* webpackChunkName: "SearchViews" */ '../views/search/SearchUserPage.vue'
    );

const SearchCampaignPage = () =>
  import(
    /* webpackChunkName: "SearchViews" */ '../views/search/SearchCampaignPage.vue'
    );

export const routeSearch = [
  {
    path: 'search/tickets',
    name: 'SearchTicketPage',
    component: SearchTicketPage,
    meta: {
      title: 'Search Ideas'
    }
  },
  {
    path: 'search/people',
    name: 'SearchUserPage',
    component: SearchUserPage,
    meta: {
      title: 'Search People'
    }
  },
  {
    path: 'search/campaigns',
    name: 'SearchCampaignPage',
    component: SearchCampaignPage,
    meta: {
      title: 'Search Campaigns'
    }
  }
];
